@if (ife_format) {
  <div class="row cl-spacing-small" [formGroup]="form">
    <div [class.col-6]="!form?.controls['metadata_reference']" [class.col-4]="form?.controls['metadata_reference']">
      <label for="aspect_ratio" class="form-label">Aspect Ratio</label>
      <select id="aspect_ratio" class="form-select" formControlName="aspect_ratio">
        <option value="ar_16x9">Force 16/9
        </option>
        <option value="ar_4x3">Force 4/3
        </option>
        <option value="pass-through">Pass-through
        </option>
      </select>
      @if (!form?.controls['aspect_ratio'].errors) {
        <p class="valid-feedback">Forces a specific aspect ratio. Set only if encode fails in automatic mode.</p>
      }
    </div>
    <div [class.col-6]="!form?.controls['metadata_reference']" [class.col-4]="form?.controls['metadata_reference']">
      <label for="watermark" class="form-label">Watermark</label>
      <select id="watermark" class="form-select" formControlName="watermark">
        <option [value]="true">Insert forensic watermark
        </option>
        <option [value]="false">No watermark
        </option>
      </select>
      @if (!form?.controls['watermark'].errors) {
        <p class="valid-feedback">Insert or omit forensic watermark.</p>
      }
    </div>
    @if (form?.controls['metadata_reference']) {
      <div class="col-4">
        <label for="metadata_reference" class="form-label">Metadata Reference<span class="required">*</span></label>
        <input id="metadata_reference" type="text" formControlName="metadata_reference">
        @if (form?.controls['metadata_reference'].errors?.required) {
          <p class="invalid-feedback">This field is
          required.</p>
        }
        @if (!form?.controls['metadata_reference'].errors) {
          <p class="valid-feedback">A format specific reference to the
          metadata.</p>
        }
      </div>
    }
  </div>
}
